import React from 'react';
import { Frame } from '../../_molecules/Frame';
import { ResourcesWrap } from '../../_organisms/ResourcesWrap';

export const ResourcesTemplate = () => {
  return (
    <Frame type="resource">
      <ResourcesWrap />
    </Frame>
  );
};